import React, { useEffect, useRef, useState } from 'react';
import styles from './ContentViewer.module.scss';
import downArrow from '../../assets/icons/collapseDown.svg';
import upArrow from '../../assets/icons/collapseUp.svg';
import threeDots from '../../assets/icons/threeDots.svg';
import { useTranslation } from '../../hooks/useTranslations';

interface Props {
  title: string;
  content: string;
  editTab?: () => void;
  isClosed?: boolean;
  isCollapsible?: boolean;
  children?: any;
  //   deleteFinding: any;
  isOptional?: boolean;
  className?: string;
  style?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
}

const ContentViewer: React.FC<Props> = ({
  title,
  content,
  editTab,
  isClosed,
  isCollapsible,
  children,
  isOptional,
  style,
  contentStyle,
}) => {
  const { translations } = useTranslation();
  const [collapse, setCollapse] = useState<boolean>(isClosed === undefined ? false : isClosed);
  const [pupUp, setpupUp] = useState<boolean>(false);
  const ref = useRef<HTMLInputElement | undefined>();

  useEffect(() => {
    const checkIfClickedOutside = (e: any) => {
      // If the menu is open and the clicked target is not within the menu, then close the menu
      if (pupUp && ref.current && !ref.current.contains(e.target)) {
        setpupUp(false);
      }
    };
    document.addEventListener('mousedown', checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [pupUp]);

  const openPopup = () => {
    if (!editTab) {
      return null;
    }
    if (pupUp)
      return (
        <div className={styles.pupUp} ref={ref as React.RefObject<HTMLDivElement>}>
          {editTab && (
            <div
              onClick={() => {
                editTab();
                setpupUp(false);
              }}
            >
              {translations('edit')}
            </div>
          )}
        </div>
      );
    else return null;
  };

  return (
    <div className={styles.mainContainer} style={{ ...style }}>
      <div
        className={styles.header}
        onClick={() => {
          if (isCollapsible) setCollapse(!collapse);
        }}
      >
        <div className={styles.titleWrap}>
          <div className={styles.title}>{title}</div>
          {isOptional && <p className={styles.optional}>({translations("label.optional")})</p>}
        </div>
        {isCollapsible && <img src={collapse ? downArrow : upArrow} alt="collapse" />}
      </div>
      {!collapse && (
        <div className={styles.content} style={{ ...contentStyle }}>
          {content && (
            <div
              dangerouslySetInnerHTML={{
                __html: content ?? '',
              }}
            />
          )}
          {children}
          {!isCollapsible && editTab ? (
            <div className={styles.threeDotsContainer} ref={ref as React.RefObject<HTMLDivElement>}>
              <img
                className={styles.dots}
                alt=""
                src={threeDots}
                onClick={() => setpupUp(!pupUp)}
              />
              {openPopup()}
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

export { ContentViewer };
